export default __webpack_public_path__ + "static/media/zoom-logo.c309bf31.png";